import { useEffect } from "react";

import useMainNavigationStore from "../stores/useMainNavigationStore";

const SUPPORT_CHAT_ITEM_ID = "support-chat";

const useMainNavigationSupportCounters = () => {
  const setItemCount = useMainNavigationStore((state) => state.setItemCount);

  useEffect(() => {
    if (window.Pylon) {
      window.Pylon("onChangeUnreadMessagesCount", function (unreadCount: number) {
        if (unreadCount > 0) {
          setItemCount(SUPPORT_CHAT_ITEM_ID, unreadCount);
        }
      });
    }
  }, [setItemCount]);
};

export default useMainNavigationSupportCounters;
